// extracted by mini-css-extract-plugin
module.exports = {"container":"container_1oLQoj","unread-tips":"unread-tips_39OAz0","unreadTips":"unread-tips_39OAz0"};